module.exports = __webpack_public_path__ + "static/media/品牌.a954c32e.svg";